<div id="{{id}}" data-position="{{position}}" class="element guide-element build-guide">
  <input type="hidden" class="guide-id" value="{{guide_id}}">
  <input type="hidden" class="guide-title" value="{{guide_title}}">
  <input type="hidden" class="page-id" value="{{page_id}}">
  <input type="hidden" class="page-title" value="{{page_title}}">
  <input type="hidden" class="image-url" value="{{image_url}}">

  <div class="image-container">
    <img src="{{image_url}}" class="image-preview" />
  </div>

  <div class="details">
    <div class="guide-title">
      {{guide_title}}
    </div>

    <div class="page-title">
      <i class="fa fa-chevron-right"></i> {{page_title}}
    </div>
  </div>
</div>
